// eslint-disable-next-line import/prefer-default-export
export const ELIGIBILITY_REJECT = 'REJECTED';
